export const isSupportItem = (item) => {
  switch (item) {
    case "4MAT_LTM":
    case "4MAT_SLP":
    case "4MAT_HMI":
    case "4MAT_TSI":
    case "4MAT_LBI":
      return true
  }
  return false
}

// PDF 리포트 템플릿이 실제로 존재하는 언어만 노출한다.
// (checkdino-report-generator/src/resource/4MAT_{ITEM}_{LANG}.pdf 기준)
const REPORT_LANGS_BY_ITEM: Record<string, string[]> = {
  "4MAT_LTM": ["ko", "en", "sv"],
}
const DEFAULT_REPORT_LANGS = ["ko", "en"]

export const REPORT_LANG_LABELS: Record<string, string> = {
  ko: "한국어",
  en: "English",
  sv: "Svenska",
}

export const reportLangsOf = (item: string): string[] => REPORT_LANGS_BY_ITEM[item] || DEFAULT_REPORT_LANGS
